export default "__VITE_ASSET__CQk7DTiB__"